<template>
  <div
    id="scroll-target"
    class="scroll-y"
    style="max-height: calc(100vh - 42px); overflow: hidden; width: auto;"
  >
    <v-layout
      v-scroll:#scroll-target="onScroll"
      style="height: auto"
    >
      <v-card
        :flat="flat || isModal ? true : false"
        style="width: 100%"
      >
        <v-card-title
          v-if="title"
          class="pb-0"
        >
          <h1 class="headline">
            {{ title }}
          </h1>
          <v-chip
            v-if="isShowCreatedDate"
            class="mx-3"
          >
            <span>Дата создания:&nbsp;</span>
            <span class="font-weight-black"> {{ createdDate | date }}</span>
          </v-chip>
        </v-card-title>
        <v-card-text class="px-2 pt-4">
          <v-form v-model="isValid">
            <v-layout
              style="height: calc(100vh - 163px);overflow-y: auto;"
              column
            >
              <v-flex
                v-if="!hideId && displayingId"
                xs1
              >
                <v-text-field
                  v-if="!hideId && displayingId"
                  class="ml-2"
                  :value="entity.id"
                  label="Ид"
                  disabled
                  outline
                  height="44"
                />
              </v-flex>
              <v-flex xs12>
                <ControlsGroup
                  v-for="(group, index) in elements"
                  :key="index"
                  :group="group"
                  :entity="entity"
                  :entity-restored="entityRestored"
                  :outline="true"
                  :is-new-entity="id === '0'"
                  :scroll-value="scrollValue"
                  @entity-change="handleEntityChange"
                />
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12>
                <slot />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-layout v-if="isConfirmed === false">
                <v-btn
                  small
                  color="primary"
                  data-test="saveAndCloseButton"
                  @click="saveAndClose"
                >
                  Подтвердить
                </v-btn>
                <v-btn
                  small
                  data-test="cancelButton"
                  @click="cancel"
                >
                  Отмена
                </v-btn>
                <v-spacer />
                <v-btn
                  v-if="entity.id !== 0 && isConfirmed === false"
                  small
                  color="error"
                  data-test="deleteButton"
                  @click="remove(entity.id)"
                >
                  Удалить
                </v-btn>
              </v-layout>

              <v-layout v-else>
                <v-btn
                  small
                  color="primary"
                  :disabled="
                    !(isValid && isChanged) || entity.isRemoved || loading
                  "
                  data-test="saveButton"
                  @click="submit(false, false)"
                >
                  {{ saveButtonTitle ? saveButtonTitle : "Сохранить" }}
                </v-btn>
                <v-btn
                  v-if="isNotification"
                  small
                  color="primary"
                  :disabled="
                    !(isValid && isChanged) || entity.isRemoved || loading
                  "
                  data-test="saveAndNotifyButton"
                  @click="submitWithNotification"
                >
                  {{ "Сохранить и уведомить" }}
                </v-btn>
                <v-btn
                  v-if="!isModal && !withoutSaveAndClose"
                  small
                  color="primary"
                  :disabled="
                    !(isValid && isChanged) || entity.isRemoved || loading
                  "
                  data-test="saveAndCloseButton"
                  @click="saveAndClose"
                >
                  Сохранить и закрыть
                </v-btn>
                <v-btn
                  small
                  data-test="cancelButton"
                  @click="cancel"
                >
                  Отмена
                </v-btn>
                <v-spacer />
                <v-btn
                  v-if="
                    (entity.id !== 0 && !isModal && !withoutRemove) ||
                      (entity.id !== 0 &&
                        isConfirmed === true &&
                        !isModal &&
                        !withoutRemove)
                  "
                  small
                  :color="entity.isRemoved ? 'success' : 'error'"
                  :data-test="
                    entity.isRemoved ? 'restoreButton' : 'deleteButton'
                  "
                  @click="changeRemovedState"
                >
                  {{ entity.isRemoved ? "Восстановить" : "Удалить" }}
                </v-btn>
              </v-layout>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import ControlsGroup from "./ControlsGroup.vue";
import { NestedEditorsEventBus } from "../nested-editors/nested-editors-event-bus.js";
import * as dataEditorApi from "../../backend/dataEditorApi.js";
import {
  getClientManager,
  assignClientManager,
} from "../../backend/clientsApi.js";

export default {
  components: {
    ControlsGroup,
  },
  props: {
    id: {
      type: String,
      required: true,
      default: "0",
    },
    title: {
      type: String,
      required: true,
    },
    resource: {
      type: String,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    addMessage: {
      type: String,
      default: "",
    },
    editMessage: {
      type: String,
      default: "",
    },
    hideId: {
      type: Boolean,
      default: false,
    },
    saveButtonTitle: {
      type: String,
      default: "",
    },
    isEventCancel: {
      type: Boolean,
      default: false,
    },
    isNotification: Boolean,
    needServerInit: Boolean,
    replaceAfterSubmit: {
      type: Boolean,
      default: true,
    },
    flat: Boolean,
    withoutSaveAndClose: Boolean,
    isShowCreatedDate: Boolean,
    withoutRemove: Boolean,
  },
  data() {
    return {
      entity: {},
      originEntity: null,
      isValid: false,
      transportType: -1,
      transportTypes: [],
      isChanged: false,
      loading: false,
      entityRestored: false,
      displayingId: false,
      scrollValue: 0,
      createdDate: null,
    };
  },
  computed: {
    fieldsToFill() {
      const fields = [];
      this.elements.forEach(r => {
        r.forEach(f => {
          fields.push(f);
        });
      });
      return fields;
    },
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
    isConfirmed() {
      if (Object.prototype.hasOwnProperty.call(this.entity, "isConfirmed")) {
        return this.entity.isConfirmed;
      }
    },
  },
  created() {
    const entity = { id: 0 };
    this.fieldsToFill.forEach(f => {
      if (f.control.type === "reference") {
        entity[f.name] = null;
      } else if (f.control.type === "multiple-reference") {
        entity[f.name] = [];
      } else if (f.control.type === "tiny-reference" && !f.default) {
        entity[f.name] = 0;
      } else if (f.control.type === "enum" && !f.default) {
        entity[f.name] = 0;
      } else {
        entity[f.name] = f.default;
      }
    });
    this.entity = entity;

    if (+this.id || this.needServerInit) {
      this.getData();
    } else {
      this.entityRestored = true;
      if (this.isShowCreatedDate) {
        this.createdDate = new Date().toISOString().substr(0, 10);
      }
    }
  },
  mounted() {
    if (this.isModal) {
      NestedEditorsEventBus.$emit("modal-editor-mounted");
    }
  },
  methods: {
    onScroll(e) {
      this.scrollValue = e.target.scrollTop;
    },
    async getData() {
      this.loading = true;

      const res = await dataEditorApi.getData(
        this.resource,
        this.needServerInit,
        this.id,
      );
      const entity = {
        id: res.data.Id,
        isRemoved: res.data.IsRemoved,
        isConfirmed: res.data.IsConfirmed,
      };
      this.fieldsToFill.forEach(f => {
        let fieldValue;
        if (f.getDataPath) {
          f.getDataPath.split(".").forEach(s => {
            fieldValue = fieldValue ? fieldValue[s] : res.data[s];
          });
        } else {
          if (Object.prototype.hasOwnProperty.call(res.data, f.name)) {
            fieldValue = res.data[f.name];
          } else if (
            Object.prototype.hasOwnProperty.call(
              res.data,
              capitalizeFirstLetter(f.name),
            )
          ) {
            fieldValue = res.data[capitalizeFirstLetter(f.name)];
          }
        }
        if (
          f.control.type === "reference" ||
          f.control.type === "manager-select"
        ) {
          if (fieldValue) {
            entity[f.name] = {
              id: fieldValue.Id,
              title: fieldValue.Title,
              isRemoved: fieldValue.IsRemoved,
              isConfirmed: fieldValue.IsConfirmed,
            };
          } else {
            entity[f.name] = null;
          }
        } else if (f.control.type === "multiple-reference") {
          entity[f.name] = fieldValue.map(v => {
            return {
              id: v.Id,
              title: v.Title,
            };
          });
        } else if (f.control.type === "tiny-reference") {
          entity[f.name] = fieldValue ? fieldValue.Id : 0;
        } else if (f.control.type === "enum" && !f.control.ojectType) {
          entity[f.name] = fieldValue ? fieldValue.Id : 0;
        } else if (f.control.type === "enum" && f.control.ojectType) {
          entity[f.name] = fieldValue
            ? { id: fieldValue.Id, title: fieldValue.Title }
            : null;
        } else if (f.control.type === "reference-list") {
          entity[f.name] = fieldValue.map(i => {
            const item = { id: i.Id };
            f.control.columns.forEach(c => {
              const fieldName = c.data || c.name;
              const fieldNameSegments = fieldName.split(".");
              let fieldValue;
              fieldNameSegments.forEach(s => {
                if (fieldValue) {
                  fieldValue = fieldValue[capitalizeFirstLetter(s)];
                } else {
                  fieldValue = i[capitalizeFirstLetter(s)];
                }
              });
              item[c.name] = fieldValue;
            });
            return item;
          });
        } else if (f.control.type === "packages") {
          entity[f.name] =
            fieldValue && fieldValue.length
              ? fieldValue.map(p => {
                return {
                  id: p.Id,
                  packageType: {
                    id: p.PackageType.Id,
                    title: p.PackageType.Title,
                  },
                  quantity: p.Quantity,
                  length: p.Length,
                  width: p.Width,
                  height: p.Height,
                };
              })
              : [];
        } else {
          if (typeof fieldValue === "string") {
            fieldValue = fieldValue.replace("T00:00:00", "");
          }
          entity[f.name] = fieldValue;
        }
      });
      this.entity = entity;
      this.originEntity = JSON.parse(JSON.stringify(entity));
      this.$emit("loadData", this.entity, res.data);
      this.entityRestored = true;
      if (this.isShowCreatedDate) {
        this.createdDate = res.data.Date;
      }

      this.loading = false;

      function capitalizeFirstLetter(src) {
        return src.charAt(0).toUpperCase() + src.slice(1);
      }
    },
    async submit(isNotification, closeAfterSubmit) {
      const entity = {
        id: this.entity.id,
        isRemoved: this.entity.isRemoved,
        isConfirm: this.entity.isConfirm,
      };
      this.fieldsToFill.forEach(f => {
        if (
          f.control.type === "reference" ||
          f.control.type === "manager-select" ||
          (f.control.type === "enum" && f.control.ojectType)
        ) {
          entity[f.name + "Id"] = this.entity[f.name]
            ? this.entity[f.name].id
            : 0;
        } else if (f.control.type === "multiple-reference") {
          entity[f.name] = this.entity[f.name].map(i => i.id);
        } else if (f.control.type === "reference-list") {
          entity[f.saveDataPath] = this.entity[f.name].map(i => i.id);
        } else if (f.control.type === "tiny-reference") {
          entity[f.name + "Id"] = this.entity[f.name];
        } else if (f.control.type === "enum") {
          entity[f.name + "Id"] = this.entity[f.name];
        } else if (
          f.control.type === "label" &&
          f.control.dataType === "boolean"
        ) {
          entity[f.name] = this.entity[f.name] === 1;
        } else if (
          f.control.type === "packages" &&
          this.entity[f.name] &&
          this.entity[f.name].length
        ) {
          entity[f.name] = this.entity[f.name].map(p => {
            return {
              packageTypeId: p.packageType.id,
              quantity: p.quantity,
              length: p.length,
              width: p.width,
              height: p.height,
            };
          });
        } else {
          if (f.saveDataPath) {
            entity[f.saveDataPath] = this.entity[f.name];
          } else {
            entity[f.name] = this.entity[f.name];
          }
        }
      });
      if (entity.id !== 0) {
        this.loading = true;

        const res = await dataEditorApi.updateData(
          this.resource,
          entity.id,
          entity,
        );
        const message = this.editMessage || "Объект изменен";
        this.showInfo(message);

        if (isNotification) {
          this.$emit("saveWithNotification");
        } else {
          this.$emit("save", res.data);
        }

        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.entity.id);
        } else {
          this.isChanged = false;
          this.$emit("change", this.isChanged);
          this.originEntity = JSON.parse(JSON.stringify(this.entity));
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
        }
        this.loading = false;
      } else {
        this.loading = true;

        const res = await dataEditorApi.createData(this.resource, entity);
        const message = this.addMessage || "Объект добавлен";
        this.showInfo(message);

        this.entity.id = res.data;

        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.entity.id);
        } else {
          if (this.replaceAfterSubmit) {
            this.$router.replace(`/${this.resource}/${res.data}`);
          }
          isNotification
            ? this.$emit("saveWithNotification")
            : this.$emit("save", res.data);
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
        }
        this.loading = false;
      }
    },
    async submitWithNotification() {
      await this.submit(true, false);
    },
    async handleEntityChange(payload) {
      if (!this.entityRestored) {
        return;
      }

      if (
        this.entityRestored &&
        payload.element &&
        payload.element.control.autoSetChildren
      ) {
        this.autoSetChildren(payload.selected, payload.element);
      }

      if (payload.element?.control?.assignClientManager) {
        await this.assignClientManager(
          this.entity.client.id,
          payload.selected.id,
        );
      }

      this.isChanged = isEntityReallyChanged(this.originEntity, this.entity);
      this.$emit("change", this.isChanged);

      function isEntityReallyChanged(origin, current) {
        if (!origin) {
          return true;
        } else {
          let isChanged = false;
          for (const property in origin) {
            if (
              typeof current[property] === "object" &&
              !Array.isArray(current[property])
            ) {
              isChanged =
                current[property] && origin[property]
                  ? origin[property].id !== current[property].id
                  : true;
            } else if (
              typeof current[property] === "object" &&
              Array.isArray(current[property])
            ) {
              let result = [];
              if (origin[property].length >= current[property].length) {
                result = origin[property].filter(
                  e => current[property].indexOf(e) < 0,
                );
              } else {
                result = current[property].filter(
                  e => origin[property].indexOf(e) < 0,
                );
              }
              isChanged = result.length > 0;
            } else {
              const originEntity =
                origin[property] === null
                  ? String.Empty
                  : origin[property].toString();

              isChanged = originEntity !== current[property]?.toString();
            }
            if (isChanged) {
              return true;
            }
          }
        }
        return false;
      }
    },
    async autoSetChildren(selected, element) {
      if (selected) {
        const res = await dataEditorApi.autoSetChildren(
          element.control.resource,
          selected.id,
        );
        if (res.data && res.data[element.control.autoSetChildren]) {
          this.$set(this.entity, element.control.autoSetChildrenField, {
            id: res.data[element.control.autoSetChildren].Id,
            title: res.data[element.control.autoSetChildren].Title,
          });
        }
      } else {
        this.$set(this.entity, element.control.autoSetChildren, null);
      }
    },
    cancel() {
      if (this.isModal) {
        NestedEditorsEventBus.$emit("close");
        return;
      }
      if (this.isEventCancel) {
        this.$emit("cancel");
      } else {
        this.$router.go(-1);
      }
    },
    async saveAndClose() {
      await this.submit(false, true);
    },
    async changeRemovedState() {
      await dataEditorApi.changeRemovedState(
        this.resource,
        this.entity.id,
        this.entity.isRemoved,
      );
      this.entity.isRemoved = !this.entity.isRemoved;
    },
    async remove() {
      await dataEditorApi.deleteData(this.resource, this.entity.id);
      this.showInfo("Объект удален");
      this.$router.go(-1);
    },
    resetLoaders() {
      this.loading = false;
    },
    async assignClientManager(clientId, managerId) {
      const manager = await getClientManager(clientId);
      if (manager.id === managerId) {
        return;
      }

      await assignClientManager(clientId, managerId);
      this.showInfo(`Менеджер клиента ${this.entity.client.title} изменен`);
    },
  },
};
</script>
